import { render, staticRenderFns } from "./projectDetails.vue?vue&type=template&id=0b7f3210&scoped=true"
import script from "./projectDetails.vue?vue&type=script&lang=js"
export * from "./projectDetails.vue?vue&type=script&lang=js"
import style0 from "./projectDetails.vue?vue&type=style&index=0&id=0b7f3210&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7f3210",
  null
  
)

export default component.exports